/** Duration after which an authenticated user is considered inactive. */
export const INACTIVITY_THRESHOLD_MS = 30 * 60 * 1000;

/** Small offset so a stamped `lastActive` is unambiguously past the inactivity threshold. */
export const EXPIRED_LAST_ACTIVE_OFFSET_MS = 1000;

/**
 * Query flag that tells `/sign-in` to require credentials after inactivity logout.
 *
 * Cookie-gated routes often land on `/sign-in` with only `redirectUrl`. The expired
 * `lastActive` cookie is the durable signal; this param is stamped when we own the URL.
 */
export const AUTH0_REAUTH_QUERY_PARAM = 'reauth';
